import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { FsBuildModule } from '@firestitch/build';

import { CardComponent } from './components';


@NgModule({
  imports: [
    RouterModule,
    FsBuildModule,
  ],
  declarations: [
    CardComponent,
  ],
  exports: [
    CardComponent,
  ],
})
export class CardModule {}
